import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import '../styles/common/Teachers.css';

import Header from '../components/common/Header.jsx';
import Footer from '../components/common/Footer.jsx';

import hero from '../assets/teachers/hero.svg';
import phone from '../assets/teachers/phone.svg';
import hand from '../assets/teachers/hand.svg';
import footerImg from '../assets/teachers/footerImg2.svg';
import pencil from '../assets/teachers/pencil.png';
import task from '../assets/teachers/task.png';
import schoolboy from '../assets/teachers/schoolboy.png';
import star from '../assets/teachers/star.png';
import smile from '../assets/teachers/smile.png';
import note from '../assets/teachers/note.png';

const features = [
    'Готові конспекти',
    'Презентації зі зрозумілими й сучасними прикладами',
    'Шаблони вправ для індивідуальної, парної та групової роботи',
    'Методичні поради: логіка пояснення, складні місця, типові помилки, методики зниження тривожності учнів',
    'Завдання для закріплення і повторення',
    'Матеріали для учнів, які пропустили тему'
];

const instructions = [
    {__html: 'Проводьте урок за готовим конспектом, пояснюйте за презентацією, а інтерактивні завдання платформи використовуйте для практики.', img: pencil },
    {__html: 'Клас не зрозумів тему? Спробуйте ще раз із платформою: учні проходять модуль із наочними прикладами та одразу закріплюють матеріал за допомогою вправ.', img: task},
    {__html: 'Поки одна група працює з вами, інша самостійно виконує завдання на платформі — ідеально для класу з різним рівнем підготовки.', img: schoolboy},
    {__html: 'БігМат може бути однією зі станцій уроку: <ul><li>станція з учителем;</li> <li>станція з роздатковими матеріалами;</li> <li>станція з інтерактивом на платформі.</li></ul>', img: star},
    {__html: 'Учні можуть пройти короткий модуль удома: повторити тему без тиску та знизити тривожність.', img: smile},
    {__html: 'Учні самостійно проходять урок на платформі та повертаються до класної роботи без прогалин.', img: note}
]


export default function TeachersPage() {
    const scrollReveal = {
        offscreen: { 
            y: 60, 
            opacity: 0 
        },
        onscreen: {
            y: 0,
            opacity: 1,
            transition: {
                type: "spring",
                bounce: 0.3,
                duration: 1
            }
        }
    };
    const handReveal = {
        offscreen: { 
            x: 150,
            opacity: 0 
        },
        onscreen: {
            x: 0,
            opacity: 1,
            transition: {
                type: "spring",
                bounce: 0.1,
                duration: 1,
                delay: 0.7
              }
            }
        };

    const handleScroll = (e) => {
        e.preventDefault();
        const element = document.getElementById('materials');
        if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <div className="page-container teachers">
            <Header />
            <section className="banner">
                <h1 className="banner__title">БігМат для&nbsp;вчителів</h1>
                <div className="banner__container">
                    <motion.img 
                        alt="Hero" 
                        src={hero} 
                        initial={{ x: -100, opacity: 0 }}
                        animate={{ x: 0, opacity: 1 }}
                        transition={{ 
                            duration: 0.8,
                            ease: "easeOut"
                        }}
                    />
                    <div className="banner__comment">
                        <p>Наші інструменти допоможуть навчати математики ефективніше: давати більше ґрунтовних знань і витрачати на це менше зусиль.</p>
                        <p>Перша тема — «Вступ до дробів» для 5–6 класів. Попереду — нові уроки, адже платформа поступово розширюватиметься.</p>
                    </div>
                </div>
            </section>

            <motion.section className="teacher__section features"
                initial="offscreen"
                whileInView="onscreen"
                viewport={{ once: true, amount: 0.2 }}
                variants={scrollReveal}
            >
                <h2 className="teacher__section-title">Усе необхідне для уроків</h2>
                <div className="features__container">
                {features.map((item, index) => (
                    <div key={index} className="feature__item"><p>{item}</p></div>
                ))}
                </div>
            </motion.section>

            <motion.section className="teacher__section instruction"
                initial="offscreen"
                whileInView="onscreen"
                viewport={{ once: true, amount: 0.2 }}
                variants={scrollReveal}
            >
                <h2 className="teacher__section-title">Як працювати із БігМат на уроці</h2>
                <p className="instruction__text">Інтегруйте БігМат в уроки по-різному — залежно від теми, формату заняття та рівня класу.</p>
                <div className="instruction__container">
                {
                    instructions.map((item, index) => (
                        <div key={index} className="instruction__item">
                            <p dangerouslySetInnerHTML={{ __html: item.__html }}></p>
                            <img src={item.img} alt=""/>
                        </div>
                    ))
                }
                </div>
            </motion.section>

            <motion.section className="teacher__section app"
                initial="offscreen"
                whileInView="onscreen"
                viewport={{ once: true, amount: 0.2 }}
                variants={scrollReveal}
            >
                <h2 className="teacher__section-title">Легко прокачати знання та&nbsp;впоратися з&nbsp;домашкою</h2>
                <div className="app__text-container">
                    <p>Запропонуйте дитині застосунок</p>
                    <p className="app__note">+ додаткові<br/>корисні матеріали</p>
                </div>
                <div className="app__img-container">
                    <img src={phone} alt=""/>
                    <motion.img 
                        src={hand} 
                        alt="Hand"
                        variants={handReveal}
                    />
                </div>
                <div className="app__buttons-container">
                    <Link to="/theme/fractions">Мерщій навчатися</Link>
                    <div onClick={handleScroll}>Корисні матеріали</div>
                </div>
            </motion.section>

            <motion.section className="teacher__section materials"
                id="materials"
                initial="offscreen"
                whileInView="onscreen"
                viewport={{ once: true, amount: 0.2 }}
                variants={scrollReveal}
            >
                <h2 className="teacher__section-title">Вступ до поняття дробу. Чисельник і&nbsp;знаменник. Справедливий поділ</h2>
                <p className="materials__subtitle">Скоро тут — усі теми застосунку</p>

                <motion.div
                    className="users-cards"
                    initial="offscreen"
                    whileInView="onscreen"
                    viewport={{ once: true, amount: 0.2 }}
                    variants={scrollReveal}
                >
                    <div className="user-cards__card-item user-cards__card-item_yellow">
                    <div className="card-content">
                        <h3>Конспект уроку</h3>
                        <div>
                            <svg width="35" height="48" viewBox="0 0 35 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0.5 3.5C0.5 1.84315 1.84315 0.5 3.5 0.5L23.4268 0.5L28.5854 5.65854L33.7439 10.8171V44.5C33.7439 46.1569 32.4008 47.5 30.7439 47.5H3.5C1.84315 47.5 0.5 46.1569 0.5 44.5L0.5 3.5Z" fill="#F1F458" stroke="black"/>
                                <path d="M23.4268 0.5V7.81707C23.4268 9.47393 24.7699 10.8171 26.4268 10.8171H33.7438" stroke="black"/>
                                <path d="M17.1099 17.5V31.5" stroke="black"/>
                                <path d="M12.1099 26.5L17.1099 31.5L22.1099 26.5" stroke="black"/>
                                <path d="M10.1099 34.5H23.1099" stroke="black"/>
                            </svg>
                        </div>
                    </div>
                    </div>

                    <div className="user-cards__card-item user-cards__card-item_pink">
                    <div className="card-content">
                        <h3>Презентація</h3>
                        <div>
                            <svg width="35" height="48" viewBox="0 0 35 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0.5 3.5C0.5 1.84315 1.84315 0.5 3.5 0.5L23.4268 0.5L28.5854 5.65854L33.7439 10.8171V44.5C33.7439 46.1569 32.4008 47.5 30.7439 47.5H3.5C1.84315 47.5 0.5 46.1569 0.5 44.5L0.5 3.5Z" fill="#F1F458" stroke="black"/>
                                <path d="M23.4268 0.5V7.81707C23.4268 9.47393 24.7699 10.8171 26.4268 10.8171H33.7438" stroke="black"/>
                                <path d="M17.1099 17.5V31.5" stroke="black"/>
                                <path d="M12.1099 26.5L17.1099 31.5L22.1099 26.5" stroke="black"/>
                                <path d="M10.1099 34.5H23.1099" stroke="black"/>
                            </svg>
                        </div>
                    </div>
                    </div>

                    <div className="user-cards__card-item user-cards__card-item_blue">
                    <div className="card-content">
                        <h3>Шаблони вправ</h3>
                        <div>
                            <svg width="35" height="48" viewBox="0 0 35 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0.5 3.5C0.5 1.84315 1.84315 0.5 3.5 0.5L23.4268 0.5L28.5854 5.65854L33.7439 10.8171V44.5C33.7439 46.1569 32.4008 47.5 30.7439 47.5H3.5C1.84315 47.5 0.5 46.1569 0.5 44.5L0.5 3.5Z" fill="#F1F458" stroke="black"/>
                                <path d="M23.4268 0.5V7.81707C23.4268 9.47393 24.7699 10.8171 26.4268 10.8171H33.7438" stroke="black"/>
                                <path d="M17.1099 17.5V31.5" stroke="black"/>
                                <path d="M12.1099 26.5L17.1099 31.5L22.1099 26.5" stroke="black"/>
                                <path d="M10.1099 34.5H23.1099" stroke="black"/>
                            </svg>
                        </div>
                    </div>
                    </div>
                </motion.div>
            </motion.section>
            <Footer 
                image={footerImg} 
                text="Максимум користі без зайвого навантаження" 
                shouldDecorate={false} 
            />
        </div>    
    );
}